// Aceita o `t` do react-i18next sem brigar com os tipos genéricos dele.
type TFunction = (...args: any[]) => any;

// Rótulos em português dos enums do Google Ads usados nos itens da RMF.

/** Tipo de correspondência do termo de pesquisa (segments.search_term_match_type, em minúsculas). */
export const searchTermMatchLabel = (t: TFunction, v?: string | null): string => {
  switch (String(v || '').toLowerCase()) {
    case 'exact': return t('campaigns.rmf.stMatchExact', 'Exata');
    case 'phrase': return t('campaigns.rmf.stMatchPhrase', 'Frase');
    case 'broad': return t('campaigns.rmf.stMatchBroad', 'Ampla');
    case 'near_exact': return t('campaigns.rmf.stMatchNearExact', 'Variante próxima da exata');
    case 'near_phrase': return t('campaigns.rmf.stMatchNearPhrase', 'Variante próxima da frase');
    default: return '—';
  }
};

/** Tipo de estratégia de lance (enum do Google, ex.: TARGET_CPA). */
export const biddingTypeLabel = (t: TFunction, type?: string | null): string => {
  switch (String(type || '').toUpperCase()) {
    case 'TARGET_CPA': return t('campaigns.rmf.bidTargetCpa', 'CPA alvo');
    case 'TARGET_ROAS': return t('campaigns.rmf.bidTargetRoas', 'ROAS alvo');
    case 'MAXIMIZE_CONVERSIONS': return t('campaigns.rmf.bidMaxConv', 'Maximizar conversões');
    case 'MAXIMIZE_CONVERSION_VALUE': return t('campaigns.rmf.bidMaxConvValue', 'Maximizar valor de conversão');
    case 'TARGET_SPEND': return t('campaigns.rmf.bidMaxClicks', 'Maximizar cliques');
    case 'MANUAL_CPC': return t('campaigns.rmf.bidManualCpc', 'CPC manual');
    case 'MANUAL_CPM': return t('campaigns.rmf.bidManualCpm', 'CPM manual');
    case 'TARGET_IMPRESSION_SHARE': return t('campaigns.rmf.bidImpShare', 'Parcela de impressões desejada');
    default: return type ? String(type).replace(/_/g, ' ').toLowerCase() : '—';
  }
};

/** Status do Google (ENABLED/PAUSED/REMOVED). */
export const googleStatusLabel = (t: TFunction, status?: string | null): string => {
  switch (String(status || '').toUpperCase()) {
    case 'ENABLED': return t('campaigns.rmf.statusEnabled', 'Ativa');
    case 'PAUSED': return t('campaigns.rmf.statusPaused', 'Pausada');
    case 'REMOVED': return t('campaigns.rmf.statusRemoved', 'Removida');
    default: return status ? String(status) : '—';
  }
};

export const fmtBRL = (v?: number | null): string =>
  v == null || isNaN(Number(v)) ? '—' : `R$ ${Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Lê número digitado em pt-BR ("12,50" ou "1.234,50"). */
export const parseDecimal = (s: string): number => {
  const raw = String(s || '').trim();
  if (!raw) return NaN;
  const norm = raw.includes(',') ? raw.replace(/\./g, '').replace(',', '.') : raw;
  return Number(norm);
};

export interface PortfolioStrategy {
  resource_name: string;
  id: string;
  name: string;
  type: string;
  status: string;
  campaigns: number;
  target_cpa: number | null;
  target_roas: number | null;
}

/** Tipos de portfólio que a tela cria/edita. */
export const PORTFOLIO_TYPES = ['MAXIMIZE_CONVERSIONS', 'TARGET_CPA', 'TARGET_ROAS', 'MAXIMIZE_CONVERSION_VALUE'] as const;

/** A meta do tipo é CPA (moeda) ou ROAS (razão)? */
export const portfolioTargetKind = (type: string): 'cpa' | 'roas' =>
  type === 'TARGET_ROAS' || type === 'MAXIMIZE_CONVERSION_VALUE' ? 'roas' : 'cpa';

export const portfolioTargetText = (p: PortfolioStrategy): string => {
  if (portfolioTargetKind(p.type) === 'roas') {
    return p.target_roas != null ? `ROAS ${(Number(p.target_roas) * 100).toLocaleString('pt-BR', { maximumFractionDigits: 0 })}%` : '—';
  }
  return p.target_cpa != null ? `CPA ${fmtBRL(p.target_cpa)}` : '—';
};
